<template>
  
  <div class="content">
    <!-- <div class="container-fluid"> -->
      <h1>Paramètres</h1>
        <b-card no-body >
          <!-- https://bootstrap-vue.org/docs/components/tabs -->
          <b-tabs content-class="mt-3" card>
            <b-tab active><template #title><i class="nc-icon nc-email-83"></i> E-MAILS</template>
              <ol>
                <table>
                  <tr><td><li><router-link :to="urlWithRedirect('/admin/edittemplate/mail_register.js')">Inscription</router-link></li></td>
                      <td>Email envoyé automatiquement quand un compte est créé</td></tr>
                  <tr><td><li>
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_forgotpassword.js')">Mot de passe oublié</router-link></li></td>
                      <td>Email envoyé automatiquement quand un mot de passe doit être réinitialisé</td></tr>
                  <tr><td><li>
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_inviteoperation.js')">Inviter à rejoindre opération</router-link></li></td>
                      <td>Email envoyé par une EU à une EE pour demander son inscription sur PPE</td></tr>
                  <tr><td><li>
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_inviteoperation_resend.js')">Inviter à nouveau à rejoindre opération</router-link></li></td>
                      <td>Email ré-envoyé par une EU à une EE pour demander son inscription sur PPE</td></tr>
                  <tr><td><li>
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_inviteoperation_ee.js')">Inviter un sous traitant à rejoindre opération</router-link></li></td>
                      <td>Email envoyé par une EE à un sous-traitant pour demander son inscription sur PPE</td></tr>
                
                  <tr><td colspan="2"><hr /> </td></tr>

                  <tr><td><li>  
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_valid_ee.js')">Validation EE</router-link></li></td>
                      <td>Email envoyé manuellement par l'admin quand une EE doit être validée par l'EU</td></tr>
                  <tr><td><li>  
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_contact_ee.js')">Modification EE</router-link></li></td>
                      <td>Email envoyé manuellement par l'admin quand une EE doit compléter ses documents</td></tr>
                  <tr><td><li>  
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_ee.js')">Contacter l'EE</router-link></li></td>
                      <td>Email envoyé manuellement par l'admin pour contacter une EE</td></tr>
                  <tr><td><li>  
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_admin_EE_saveCompany.js')">VALIDATION de l'EE admin</router-link> </li></td>
                      <td>Email envoyé automatiquement à l'admin quand une EE change des données de son B1</td></tr>
                  <tr><td><li>  
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_admin_EE_saveDx.js')">VALIDATION de l'EE sur opération admin</router-link></li></td>
                      <td>Email envoyé automatiquement à l'admin quand une EE change des données sur D3 ou D4 de l'opération</td></tr>
                  <tr><td><li>  
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_admin_changes.js')">Un changement a été détecté admin</router-link></li></td>
                      <td>Email envoyé automatiquement à l'admin quand une EE change des données</td></tr>
                  <tr><td><li>  
                      <router-link :to="urlWithRedirect('/admin/edittemplate/mail_error.js')">Une erreur est survenue admin</router-link></li></td>
                      <td>Email envoyé automatiquement à l'admin quand une erreur arrive</td></tr>

                    </table>          
                  </ol>
            </b-tab>
            <b-tab><template #title><i class="nc-icon nc-paper-2"></i> PDF</template>
                    <li>
                      <router-link :to="urlWithRedirect('/admin/edittemplate/template_ppe.html')">PDF Plan de Prévention Evolutif</router-link>
                    </li>
                    <li>
                      <router-link :to="urlWithRedirect('/admin/edittemplate/template_d1.html')">PDF D1-PROTOCOLE DE SECURITE</router-link>
                    </li>
                    <li>
                      <router-link :to="urlWithRedirect('/admin/edittemplate/template_d4.html')">PDF D4-Bordereau d’Engagement SST de l’OPERATION</router-link>
                    </li>
            </b-tab>
            <b-tab><template #title><i class="nc-icon nc-settings-gear-64"></i> Options</template>
              
                <p class="custom-control custom-switch d-flex align-items-center">
                  <input type="checkbox" class="custom-control-input" id="customSwitch2" :checked="sendEmails" v-model="sendEmails" @blur="setSendEmails()" />
                  <label class="custom-control-label" for="customSwitch2">Activer l'envoi d'emails</label>
                </p>
              
              <p>
                <i class="nc-icon nc-cloud-download-93"></i><a href="#"  @click="downloadCachedStrings" class="card-link"> Télécharger les textes modifiés en js</a>
              </p>
            </b-tab>
          </b-tabs>
        </b-card>
      
      
        <!-- Default checked -->
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="customSwitch1" :checked="labelEditMode" v-model="labelEditMode" @blur="setEditMode()" />
          <label class="custom-control-label" for="customSwitch1">Autoriser la modification des textes</label>
        </div>

    <!-- </div> -->
  </div>
</template>


<script>
  import ppeBusiness from 'ppe-business'
import common from '../common/pages.js'

  export default {
    data() {
      return {
        labelEditMode : this.$features.labelEditMode,
        sendEmails    : ppeBusiness.sendEmails,
      }
    },
    mounted() {
      this.$http.get(`/admin/settings`)
      .then(response => {
        console.log("/admin/settings DATA", response.data)
        this.sendEmails = response.data.settings.sendEmails
      })},

    methods: {
      ...common.methods,

      setEditMode() {
        this.$features.labelEditMode = this.labelEditMode
      },
      setSendEmails() {
        this.$http.post('/admin/setting', {settingName:'sendEmails', settingValue:this.sendEmails}) 
      },

      downloadCachedStrings(){
        this.$http.get('/admin/downloadresourcesstrings', {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          let blob = new Blob([response.data], { type: 'application/text' })
          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'resources.js'
          link.click()
        })
        .catch( err => {
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
        })
      },
    }
  }
</script>